export default __webpack_public_path__ + "static/media/head.ea8b2044.svg";